import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useGetProjectsByOrgIdAndCrmSystemProps } from "./useGetProjectsByOrgIdAndCrmSystem.types";

export function useGetProjectsByOrgIdAndCrmSystem({ orgId, crmSystem, archived, sortByCreatedAtAscending, isOpened }: { isOpened: boolean } & useGetProjectsByOrgIdAndCrmSystemProps) {
    return useQuery({
        ...queryKeys.project.list._ctx.byOrgId({ orgId, sortByCreatedAtAscending })._ctx.byCrmSystem({ crmSystem, archived, sortByCreatedAtAscending }),
        enabled: !!orgId && !!crmSystem && isOpened,
    });
}
